import * as React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

import EmbeddedVideo from "common/components/embeddedVideo";
import { LocationDescriptor } from "history";

const styles = require("../contentPlaceholder.scss");

interface IEmbeddedVideoWrapperProps {
  summaryData: Vingle.CardContent.MediaData[];
  componentWidth: number;
  targetUrl: LocationDescriptor;
}

const ratio = 9 / 16;
class EmbeddedVideoWrapper extends React.PureComponent<
  IEmbeddedVideoWrapperProps
> {
  public render() {
    const { summaryData } = this.props;
    if (summaryData.length === 1) {
      return this.oneEmbeddedVideoContainer();
    } else if (summaryData.length > 1) {
      return this.manyDataContainer();
    } else {
      return null;
    }
  }

  private readonly oneEmbeddedVideoContainer = () => {
    const width = this.props.componentWidth;
    const height = width * ratio;

    return (
      <EmbeddedVideo
        style={{ borderRadius: "0 0 12px 12px" }}
        width={width}
        height={height}
        embeddedVideo={
          this.props.summaryData[0] as Vingle.CardContent.EmbeddedVideoData
        }
      />
    );
  };

  private readonly manyDataContainer = () => {
    const { summaryData, targetUrl } = this.props;
    const remainCount = summaryData.length - 1;
    const width = this.props.componentWidth;
    const height = width * ratio;

    return (
      <div className={styles.embeddedFirstWrapper}>
        <div className={styles.item}>
          <EmbeddedVideo
            style={{ borderRadius: "0 0 12px 12px" }}
            className={styles.item}
            width={width}
            height={height}
            embeddedVideo={
              this.props.summaryData[0] as Vingle.CardContent.EmbeddedVideoData
            }
          />
        </div>

        <Link to={targetUrl}>
          <div className={styles.mediaMore}>
            <FormattedMessage
              id={"card.mediaSummary.embeddedVideo.more"}
              values={{ media_count: remainCount.toString() }}
            />
          </div>
        </Link>
      </div>
    );
  };
}

export default EmbeddedVideoWrapper;
